import { render, staticRenderFns } from "./copersatisiadeislem.vue?vue&type=template&id=5e1af35d&"
import script from "./copersatisiadeislem.vue?vue&type=script&lang=js&"
export * from "./copersatisiadeislem.vue?vue&type=script&lang=js&"
import style0 from "./copersatisiadeislem.vue?vue&type=style&index=0&id=5e1af35d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports